import { render, staticRenderFns } from "./TheOnloPhone.vue?vue&type=template&id=6ae4f05c&"
import script from "./TheOnloPhone.vue?vue&type=script&lang=js&"
export * from "./TheOnloPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports